module.exports = __webpack_public_path__ + "static/media/conference_financeurs.779d41bd.svg";